import { contactEntry } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            {contactEntry.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {contactEntry.desc}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactEntry.items.map((item, i) => (
              <div
                key={i}
                className="p-5 rounded-lg bg-background-50 border border-background-200/70 text-center"
              >
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-50">
                  <i className={`text-lg text-accent-500 ${item.icon}`}></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">{item.label}</div>
                <div className="text-sm font-medium text-foreground-800 break-all">
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}